export default __webpack_public_path__ + "static/media/successMsg2.df1c8bb8.svg";